import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { PagesCarousel } from './components/PagesCarousel';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { PracticeCard } from './components/PracticeCard';
import { WhoFor } from './components/WhoFor';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3ikh8ubu2yx01">
      <MetaPixel data-id="element-1" data-mp="3mkrchhuehbbq" />
      <main data-id="element-2" data-mp="3mk84asujy1aw">
        <Hero data-id="element-3" data-mp="3mjq1tehaqquj" />
        <SocialProofBar data-id="element-4" data-mp="3mjgczu7zmpqf" />
        <PainGrid data-id="element-5" data-mp="3rcj7c4kla37o" />
        <ProductReveal data-id="element-6" data-mp="3rbznujfaj6rj" />
        <Tomes data-id="element-7" data-mp="3rcsyhvhdegey" />
        <PagesCarousel data-id="element-8" data-mp="3recerm310rgq" />
        <Testimonials data-id="element-9" data-mp="5yhupa6n3cr" />
        <Bonuses data-id="element-10" data-mp="67znpl2q47d" />
        <ValueStack data-id="element-11" data-mp="4n4pyuukj8z" />
        <Urgency data-id="element-12" data-mp="56lvdcob3ly" />
        <Pricing data-id="element-13" data-mp="7ssnarqpf34" />
        <PracticeCard data-id="element-14" data-mp="2zld2xbxu5jcl" />
        <Guarantee data-id="element-15" data-mp="2zlv32jnmchps" />
        <Faq data-id="element-16" data-mp="2zmo557bmuj1l" />
        <WhoFor data-id="element-17" data-mp="2zmwh8wzxlkbq" />
        <CostOfInaction data-id="element-18" data-mp="2zng2amkvootz" />
        <Close data-id="element-19" data-mp="33m5a7zn5de68" />
      </main>
      <Footer data-id="element-20" data-mp="33ngee0ki8nxv" />
    </div>;
}